// The one button. variant = primary | secondary | ghost | destructive.
// size = md (44px, default) | sm (36px). `block` fills width, `icon` makes it
// square for a lone glyph. All states (hover/active/focus/disabled) live in
// primitives.css — this just picks classes.
export function Button({
  variant = "primary", size = "md", block = false, icon = false,
  className = "", type = "button", children, ...rest
}) {
  const cls = [
    "bz-btn",
    `bz-btn--${variant}`,
    size === "sm" && "bz-btn--sm",
    block && "bz-btn--block",
    icon && "bz-btn--icon",
    className,
  ].filter(Boolean).join(" ");
  return <button type={type} className={cls} {...rest}>{children}</button>;
}
